import { Button } from '@hud/web-components/Button/Button';
import { smBold } from '@hud/web-components/theme/typography';
import styled, { keyframes } from 'styled-components';
import { TOP_BANNER_HEIGHT } from '@hud/web-components/Layout/Layout';
import { themeColor } from '@hud/web-components/theme/colors';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

export const Container = styled.div<{ exceededLimit: boolean }>`
  ${smBold};
  height: ${TOP_BANNER_HEIGHT}px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;

  z-index: 1000;

  color: #111214;

  background-color: ${({ exceededLimit }) =>
    exceededLimit ? '#DC6900' : themeColor('turquoiseTertiary')};

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  opacity: 0;
  animation: ${fadeIn} 0.3s ease-out forwards;
  animation-delay: 0.1s;
`;

export const FreePlanIndicator = styled.div<{ limitReached: boolean }>`
  ${smBold};
  height: 28px;
  padding: 2px 12px;
  display: flex;
  align-items: center;

  border-radius: 8px;

  color: ${({ limitReached }) => (limitReached ? '#ff7a00' : '#0ffee6')};

  background: ${({ limitReached }) => (limitReached ? '#4e2908' : '#065c53')};
`;

export const UpgradeButton = styled(Button)<{ limitReached: boolean }>`
  ${smBold};
  height: 28px;
  padding: 8px 16px;
  background: white;
  color: #111214;
  border-radius: 8px;
  border: 0px;
  &:hover {
    ${({ limitReached }) =>
      limitReached
        ? `
      background: #FAE9D9;
    `
        : `
      background: #E0F7F5;
    `}
  }
`;
